export var filterSellers = function filterSellers(sellers) {
  return sellers.filter(function (seller) {
    return seller.showPhone && seller.phone && seller.phone.number;
  });
};